var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "item" }, [
    _c(
      "a",
      {
        attrs: {
          href: _vm.result.Url,
          title: _vm.result.Name,
          target: "_blank"
        }
      },
      [
        _c("span", [_vm._v(_vm._s(_vm.result.Name))]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.formatDate(_vm.result.PublishDate)))])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b6104bc", { render: render, staticRenderFns: staticRenderFns })
  }
}